<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="mat-elevation-z8 m-2">
  <table mat-table [dataSource]="dataSource" class="w-100">
    <ng-container matColumnDef="permissions">
      <th mat-header-cell *matHeaderCellDef>Permissions</th>
      <th mat-header-cell *matHeaderCellDef>All</th>
      <td mat-cell *matCellDef="let permission">
        <button mat-icon-button color="primary" [matTooltip]="permissionMap.get(permission)" [matTooltipShowDelay]="0">
          <mat-icon class="mdi-24px" fontIcon="mdi-information"> </mat-icon>
        </button>
        {{ permission }}
      </td>
    </ng-container>

    <ng-container *ngFor="let role of roles$ | async; trackBy: trackById" [matColumnDef]="role.name">
      <th mat-header-cell *matHeaderCellDef>
        <div class="d-flex">
          <p>{{ role.name }}</p>
        </div>
      </th>
      <td mat-cell *matCellDef="let permission">
        <mat-checkbox *ngIf="permission == allPermission || !role.allPermissions" color="primary"
          [checked]="hasPermission(permission, role)" disabled="true"></mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns$ | async; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns$ | async"></tr>
  </table>
</div>